import { Link, useLocation } from "react-router-dom";
import { ArrowRight } from "lucide-react";

// Pages where the floating enroll button should NOT appear
const HIDDEN_PATHS = ["/enroll", "/join", "/lms-manager", "/lms", "/admin", "/support", "/pro"];

// All plans that indicate the student has already paid/enrolled
const PAID_PLANS = ["tier2_pro", "lokesh_notes", "unlimited", "premium", "paid", "basic", "standard", "pro"];

export default function FloatingEnrollButton({ user }) {
  const location = useLocation();

  // Only show for unauthenticated users OR users with explicitly "free" plan
  // Any logged-in user without an explicit "free" plan is treated as enrolled
  if (user && user.plan !== "free") return null;

  // Hide on certain pages
  if (HIDDEN_PATHS.some((p) => location.pathname.startsWith(p))) return null;

  return (
    <Link
      to="/enroll"
      data-testid="floating-enroll-btn"
      className="fixed bottom-6 left-6 z-50 group flex items-center gap-2.5 shadow-2xl"
      style={{ filter: "drop-shadow(0 0 18px rgba(245,158,11,0.45))" }}
    >
      {/* Pulse ring */}
      <span className="absolute inset-0 rounded-full animate-ping bg-amber-400/30 pointer-events-none" />

      <div className="relative flex items-center gap-2.5 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-400 hover:to-orange-400 text-white font-black text-base px-6 py-3.5 rounded-full transition-all hover:scale-105 hover:-translate-y-0.5 active:scale-95 whitespace-nowrap shadow-lg">
        {/* Crown icon */}
        <svg viewBox="0 0 20 20" fill="currentColor" className="w-5 h-5 shrink-0">
          <path d="M10 2L12.5 7.5L18 6L15 13H5L2 6L7.5 7.5L10 2Z" />
        </svg>
        Enroll Now
        <span className="bg-white/30 text-white text-sm font-black px-2.5 py-0.5 rounded-full">
          ₹499
        </span>
        <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
      </div>
    </Link>
  );
}
